import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";

export const resendCodeRequest = reatomAsync((ctx, email: string) => {
  return API.authApi.authControllerGetCode(email);
}).pipe(withDataAtom(null));
